<!-- @format -->

<template>
  <a-select :style="{ width: width + 'px' }" :value="model" @change="handleChange">
    <a-select-option :key="item.label" v-for="item in computedDataList" :value="item.value">{{
      item.label
    }}</a-select-option>
  </a-select>
</template>
<script>
/** @format */
import Utils from '@/utils/common';
import mixedUtils from '../utils.js';
import lodash from 'lodash';
import compWrapperMixin from './comp-wrapper-mixin.js';
export default {
  mixins: [compWrapperMixin],
  mounted() {
    if (!this.vm.isProd()) {
      window.SINGLE_FORM_DICT_SELECT = this;
    }
    console.log('compDefine in singleFormDIctSelect-:', this.$props, window.decodeURIComponent(this.tpl));
    // this.model = this.value
    console.log('dict--:', this.dict);
    this.dataList = lodash.isArray(this.dict)
      ? this.dict
      : Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries[this.dict]);

    console.log('修改前的model--:', this.model);
    if (window.isNaN(this.model - 0)) {
      try {
        this.model = this.dataList.find(item => item.label == this.model).value;
        this.handleChange(this.model);
      } catch (e) {
        // console.warn('e---', e)
        void 0;
      }
    }

    console.log('修改后的model--:', this.model);

    // this.vm.unshiftWholeItem4Select(this.dataList)
  },
  computed: {
    computedDataList() {
      return this.dataList.filter(item => !(this.$props.compDefine.removeItems || []).find(row => row == item.label));
    }
  },
  data() {
    return {
      // model: '',
      dataList: []
    };
  }
};
</script>
